export default "images/pixelization.png";